module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-1.133d57bc.jpg";